import Sidebar from './Component/Sidebar/Sidebar';
import About from './Component/About/About';
import TechStack from './Component/TecStack/TechStack';
import Projects from './Component/Projects/Projects';
import WorkExperiance from './Component/WorkExpreiance/WorkExperiance';
import Education from './Component/Education/Education';
import Testimonial from './Component/Testimonial/Testimonial';
import Contact from './Component/Contact/Contact';
import ScrollToTop from "react-scroll-to-top";
import "./App.css"
import NavbarMobileView from './Component/Sidebar/NavbarMobileView';
import { createContext, useState } from 'react';


export const themeContext = createContext(null);


const App = () => {

  const [theme, setTheme] = useState("light");

  const changeTheme = () => {
    setTheme((prev) =>  prev === "light" ? "dark" : "light");
  }

  return (
    <themeContext.Provider value={{ theme, changeTheme }}>

      <div id={theme}>
        <NavbarMobileView  changeTheme={changeTheme} theme={theme}/>
        <Sidebar changeTheme={changeTheme} theme={theme} />
        <About />
        <TechStack />
        <Projects />
        <WorkExperiance />
        <Education />
        <Testimonial />
        <Contact />
        <ScrollToTop smooth={true}
          // top="600" 
          color='white'
          height='20'
          width='20'
          style={{ borderRadius: "90px", backgroundColor: "#38004c", }} />
      </div>

    </themeContext.Provider>
  );
}

export default App;
